import { store } from '@risingstack/react-easy-state';
import { SlotBulkActions } from './constants';
import { IEventComponent } from '../../../../../components/ui/Calendar/components/Event/Event.interfaces';

export const liveCalendarBulkActionStore = store<{
  action: SlotBulkActions;
  selectedSlots: IEventComponent[];
}>({
  action: null,
  selectedSlots: [],
});
